import { PillTheme } from "@redotech/redo-model/pill-theme";
import classnames from "classnames";
import { memo } from "react";
import { Flex } from "../flex";
import * as tagInputColorPickerCss from "./tag-input-color-picker.module.css";

const pillThemeClass: Record<PillTheme, string> = {
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.PRIMARY]: tagInputColorPickerCss.primary,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.NORMAL]: tagInputColorPickerCss.normal,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.PRIMARY_LIGHT]: tagInputColorPickerCss.primaryLight,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SUCCESS]: tagInputColorPickerCss.success,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.DANGER]: tagInputColorPickerCss.danger,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.NEUTRAL_YELLOW]: tagInputColorPickerCss.neutralYellow,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.NEUTRAL_BLUE]: tagInputColorPickerCss.neutralBlue,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.LIGHT_PINK]: tagInputColorPickerCss.lightPink,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_RED]: tagInputColorPickerCss.solidRed,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_YELLOW]: tagInputColorPickerCss.solidYellow,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_GREEN]: tagInputColorPickerCss.solidGreen,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_NAVY]: tagInputColorPickerCss.solidNavy,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_LIGHT_BLUE]: tagInputColorPickerCss.solidLightBlue,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_PINK]: tagInputColorPickerCss.solidPink,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_ORANGE]: tagInputColorPickerCss.solidOrange,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_BLACK]: tagInputColorPickerCss.solidBlack,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_WHITE]: tagInputColorPickerCss.solidWhite,
};

export const PillThemeNames: Record<PillTheme, string> = {
  [PillTheme.NORMAL]: "Gray",
  [PillTheme.PRIMARY_LIGHT]: "Purple",
  [PillTheme.LIGHT_PINK]: "Pink",
  [PillTheme.DANGER]: "Red",
  [PillTheme.NEUTRAL_YELLOW]: "Yellow",
  [PillTheme.SUCCESS]: "Green",
  [PillTheme.NEUTRAL_BLUE]: "Blue",
  [PillTheme.SOLID_RED]: "Solid red",
  [PillTheme.SOLID_YELLOW]: "Solid yellow",
  [PillTheme.SOLID_GREEN]: "Solid green",
  [PillTheme.SOLID_NAVY]: "Solid navy",
  [PillTheme.SOLID_LIGHT_BLUE]: "Solid blue",
  [PillTheme.SOLID_PINK]: "Solid pink",
  [PillTheme.SOLID_ORANGE]: "Solid orange",
  [PillTheme.SOLID_BLACK]: "Solid black",
  [PillTheme.PRIMARY]: "Solid purple",
  [PillTheme.SOLID_WHITE]: "Solid white",
};

export const PillColorPicker = memo(function PillColorPicker({
  value,
  setValue,
  options = Object.values(PillTheme),
}: {
  value: PillTheme | undefined;
  setValue(theme: PillTheme): void;
  options?: PillTheme[];
}) {
  const display = (option: PillTheme) => <ColorSquare theme={option} />;

  return (
    <Flex>
      {options.map((option) => (
        <Flex align="center" gap="xl" key={option}>
          <div
            className={
              value === option
                ? classnames(
                    tagInputColorPickerCss.container,
                    tagInputColorPickerCss.selected,
                  )
                : tagInputColorPickerCss.container
            }
            onClick={() => setValue(option)}
          >
            {display(option)}
          </div>
        </Flex>
      ))}
    </Flex>
  );
});

const ColorSquare = memo(function ColorSquare({ theme }: { theme: PillTheme }) {
  return (
    <Flex align="center" gap="xl">
      <div
        className={classnames(
          tagInputColorPickerCss.colorSquare,
          pillThemeClass[theme],
        )}
      />
    </Flex>
  );
});
